export default __webpack_public_path__ + "static/media/abouUsBanner.97cd58b8.jpg";